<template>
  <view-container>
    <list-header :add="false">
      <v-col cols="12" md="12" v-if="!auth.user.isClient">
        <reference-field label="Клиент" reference="client" v-model="clientId" />
      </v-col>
      <v-col cols="12" md="4">
        <reference-field
          :disabled="auth.user.isPartner && !clientId"
          label="Группа касс"
          reference="group"
          :filter="groupFilter"
          :rels="['company']"
          item-text="nameWithCompany"
          v-model="groupId"
        />
      </v-col>
      <v-col cols="12" md="4">
        <reference-field
          :disabled="auth.user.isPartner && !clientId"
          label="Кассир"
          reference="cashier"
          :filter="cashierFilter"
          v-model="filter.cashierId"
        />
      </v-col>
      <v-col cols="12" md="4">
        <reference-field
          label="Номенклатурная группа"
          reference="itemGroup"
          :filter="itemGroupFilter"
          v-model="filter.itemGroupId"
          :disabled="itemGroupDisabled"
        />
      </v-col>
      <v-col cols="12" md="12">
        <date-range-filter
          v-model="dateRange"
          :presets="datePresets"
          max="now"
        />
      </v-col>
    </list-header>
    <v-row>
      <v-col cols="12" md="12">
        <v-card>
          <v-card-text>
            <p>
              Для создания отчета выберите группу касс, период времени
              регистрации чеков и кликните на кнопку с требуемым форматом файла
              (отчеты могут быть выгружены в форматах <code>.csv</code> или
              <code>.xlsx</code> ). <b>Примечание:</b> при подсчете статистики
              чеки возврата вычитаются.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-alert
      type="warning"
      dense
      dismissible
      :icon="false"
      v-model="noDataFound"
    >
      <v-row align="center" dense>
        <v-col class="grow">За указанный период данных не найдено</v-col>
      </v-row>
    </v-alert>
    <v-row>
      <v-col v-for="(report, index) in reports" :key="index" cols="12" md="6">
        <report-card
          :title="report.title"
          v-on:create="createReport"
          :index="index"
          :is-disabled="report.disabled"
          :loading="loading"
        >
        </report-card>
      </v-col>
    </v-row>
  </view-container>
</template>
<script>
import ds from "@/datastore";
import moment from "moment";
import { auth } from "@/mixins";
import iconv from "iconv-lite";
var a = document.createElement("a");
document.body.appendChild(a);
a.style = "display: none";
export default {
  name: "ReportList",
  mixins: [auth],
  data() {
    return {
      clientId: undefined,
      groupId: undefined,
      filter: {
        cashierId: undefined,
        createdFrom: undefined,
        createdTo: undefined,
        itemGroupId: undefined
      },
      noDataFound: false,
      reports: [
        {
          title: "Отчет по кассирам (водителям)",
          type: "cashiers",
          disabled: true
        },
        {
          title: "Отчет по местам расчета",
          type: "places",
          disabled: true
        },
        {
          title: "Отчет по номенклатурным группам",
          type: "groups",
          disabled: true
        },
        {
          title: "Отчет по номенклатурным позициям",
          type: "items",
          disabled: true
        }
      ],
      loading: false
    };
  },
  computed: {
    groupFilter() {
      return this.clientId ? { clientId: this.clientId } : {};
    },
    cashierFilter() {
      let f = {};
      if (this.clientId) {
        f.clientId = this.clientId;
      }
      if (this.groupId) {
        f.groupId = this.groupId;
      }
      return f;
    },
    itemGroupFilter() {
      return { clientId: this.clientId };
    },
    itemGroupDisabled() {
      return !this.auth.user.isClient ? (this.clientId ? false : true) : false;
    },
    dateRange: {
      set(v) {
        if (v.length == 2) {
          this.filter.createdFrom = moment(v[0]).format();
          this.filter.createdTo = moment(v[1]).format();
        } else if (v.length == 1) {
          this.filter.createdFrom = moment(v[0])
            .startOf("day")
            .format();
          this.filter.createdTo = moment(v[0])
            .endOf("day")
            .format();
        } else {
          this.filter.createdFrom = undefined;
          this.filter.createdTo = undefined;
        }
      },
      get() {
        return [];
      }
    },
    datePresets() {
      let dp = [
        {
          title: "Сегодня",
          range: () => [moment(this.now).format()],
          default: true
        },
        {
          title: "Вчера",
          range: () => [
            moment(this.now)
              .subtract(1, "days")
              .format()
          ]
        }
      ];
      for (let i = 2; i < 5; i++) {
        dp.push({
          title: moment(this.now)
            .subtract(i, "days")
            .format("L"),
          range: () => [
            moment(this.now)
              .subtract(i, "days")
              .format()
          ]
        });
      }
      return dp;
    }
  },
  watch: {
    groupId: function(val) {
      this.reports.forEach(i => {
        i.disabled = !val;
      });
    },
    "filter.itemGroupId": function(val) {
      this.reports.forEach(i => {
        if (i.type != "groups") {
          i.disabled = Boolean(val);
        }
      });
    }
  },
  methods: {
    async createReport([index, format]) {
      this.loading = true;
      let type = this.reports[index].type;
      let r = await ds.getMapper("report").createReport(null, {
        data: {
          groupId: this.groupId,
          format: format,
          type: type,
          dateFrom: this.filter.createdFrom,
          dateTo: this.filter.createdTo,
          cashierId: this.filter.cashierId,
          itemGroupId: this.filter.itemGroupId
        }
      });
      if (!r.data.data) {
        this.noDataFound = true;
        this.loading = false;
        return;
      }
      let data, ext;
      if (format == "xlsx") {
        data = atob(r.data.data);
        data = Uint8Array.from(data, c => c.charCodeAt(0));
        ext = ".xlsx";
      } else {
        let jsonData = this.baseToString(r.data.data);
        if (jsonData === "[]") {
          this.noDataFound = true;
          this.loading = false;
          return;
        }
        data = this.createCSV(jsonData, this.baseToString(r.data.headers));
        ext = ".csv";
      }
      this.noDataFound = false;
      let title =
        "report-" +
        type +
        "-" +
        this.filter.createdFrom.slice(0, -6) +
        "-" +
        this.filter.createdTo.slice(0, -6) +
        ext;
      this.saveData(data, title);
      this.loading = false;
    },
    saveData(data, fileName) {
      const blob = new Blob([data], { type: "octet/stream" });
      const url = window.URL.createObjectURL(blob);
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
    },
    createCSV(json, h) {
      json = JSON.parse(json);
      let fields = Object.keys(json[0]);
      let csv = json.map(row =>
        fields.map(fieldName => row[fieldName]).join(";")
      );
      let fieldsName = JSON.parse(h);
      csv.unshift(fieldsName.join(";"));
      csv = csv.join("\r\n");
      csv = iconv.encode(csv, "win1251");
      return csv;
    },
    baseToString(s) {
      return decodeURIComponent(
        atob(s)
          .split("")
          .map(function(c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
    }
  }
};
</script>
